var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanInterior = function SvgCleanInterior(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clean-interior_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.962 20.889c-.571 2.663-1.87 3.228-3.225 3.638-.07.022-.06.13.012.143 2.626.445 2.975 2.462 3.202 3.775l.002.009c.012.072.114.074.132.003.79-3.11 1.992-3.383 3.48-3.76.07-.017.068-.119-.002-.135-2.804-.642-3.047-2.409-3.474-3.684-.021-.064-.113-.056-.127.01Zm-5.217-15.23c-.434 1.901-1.39 2.349-2.396 2.653-.07.021-.061.133.012.147 1.909.355 2.203 1.782 2.377 2.753.012.072.114.073.133.003.597-2.218 1.491-2.46 2.596-2.732.07-.017.067-.121-.004-.138-2.058-.487-2.275-1.755-2.59-2.695-.022-.064-.112-.057-.128.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.078 16.969c0-.19.08-.37.218-.498l10.1-9.3a.7.7 0 0 1 .113-.085l.035-.021a.68.68 0 0 1 .407-.092l1.426.13c.14.012.274.069.38.16l10.763 9.265c.15.129.235.316.235.513v14.843c0 .184-.075.36-.207.487l-.975.94a.68.68 0 0 1-.48.19l-21.349-.324a.676.676 0 0 1-.666-.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#clean-interior_svg__b)",
    fillOpacity: 0.6,
    d: "M8.078 16.969c0-.19.08-.37.218-.498l10.1-9.3a.7.7 0 0 1 .113-.085l.035-.021a.68.68 0 0 1 .407-.092l1.426.13c.14.012.274.069.38.16l10.763 9.265c.15.129.235.316.235.513v14.843c0 .184-.075.36-.207.487l-.975.94a.68.68 0 0 1-.48.19l-21.349-.324a.676.676 0 0 1-.666-.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M18.452 7.35a.424.424 0 0 1 .549 0l11.331 9.654c.094.08.148.198.148.322V32.83a.423.423 0 0 1-.422.423H7.396a.423.423 0 0 1-.423-.423V17.326c0-.124.054-.242.148-.322z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m22.488 30.082-.446.446a.068.068 0 0 1-.115-.042l-.324-3.562q-.002-.015.004-.029l.836-2.342a.1.1 0 0 0 .004-.023v-.813q0-.021.012-.038l3-4.5a.07.07 0 0 1 .086-.022l.255.127q.03.016.036.047l.099.494a.74.74 0 0 1-.128.583l-2.51 3.453a.81.81 0 0 0-.003.681c.168.338-.001.845-.509 2.03-.337.787-.23 2.02-.087 2.801a.8.8 0 0 1-.21.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.057 6.339c-.864 4.08-2.909 4.854-5.013 5.463-.071.021-.06.13.013.14 4.201.614 4.643 3.767 4.99 5.697.013.072.114.07.132 0 1.207-4.771 3.075-5.091 5.396-5.666.07-.017.065-.12-.006-.135-4.42-.93-4.712-3.626-5.384-5.512-.023-.064-.114-.054-.128.013"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M11.122 21.244h15.22c.234 0 .424.19.424.423v11.585H10.699V21.667c0-.234.19-.423.423-.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.507,
    d: "m10.61 33.335 6.088-5.58m0 0v-6.427m0 6.427h10.147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M20.59 23.19c-.846.17-1.096.677-1.86 1.691-.076.101-.881.893-1.124 1.014-.233.116-1.634.848-2.346 1.15a.064.064 0 0 0-.025.102c.27.304 1.145 1.121 2.371 1.778 1.238.662 3.204 1.288 4.187 1.429.053.007.093-.048.075-.099-.135-.384-.264-1.216-.264-1.823 0-.862.07-1.817.677-2.875.776-1.352-.58-2.59-1.692-2.367Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.573 26.92a.254.254 0 0 0-.358-.358zm1.22.292a.254.254 0 0 0-.431-.265zm-3.598.713.08.24c1.036-.344 1.922-.868 2.298-1.244l-.18-.18-.178-.18c-.3.3-1.106.792-2.1 1.123zm2.03 1.353.216.133 1.353-2.199-.216-.133-.216-.133-1.353 2.2zm2.073-1.771a.254.254 0 1 1 .482.16zm.24 2.616-.234.096c-.215-.527-.242-1.121-.206-1.613a5 5 0 0 1 .2-1.1l.241.08.24.08c-.049.15-.142.525-.175.977-.033.454-.004.96.17 1.384z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "clean-interior_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.088,
    height: 1.691,
    x: 21.016,
    y: 23.189,
    rx: 0.338,
    transform: "rotate(-54.439 21.016 23.189)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 6.088,
    height: 1.691,
    x: 21.016,
    y: 23.189,
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.015,
    mask: "url(#clean-interior_svg__c)",
    rx: 0.338,
    transform: "rotate(-54.439 21.016 23.189)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clean-interior_svg__b",
    x1: 35.867,
    x2: -17.952,
    y1: 19.804,
    y2: -3.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clean-interior_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgCleanInterior;